'use client'
import { useLanguage } from '@repo/shared/hooks'
import { DirectionProvider as DirectionProviderWrapper } from '@repo/ui/components'

export function DirectionProvider({ children }: { children: React.ReactNode }) {
  const language = useLanguage()
  return (
    <DirectionProviderWrapper dir={language === 'fa' ? 'rtl' : 'ltr'}>
      {children}
    </DirectionProviderWrapper>
  )
}

export default DirectionProvider
